import { Chip } from '@mui/material';

export default function ArchivedChip() {
  return (
    <Chip
      label="Архівовано"
      size="small"
      variant="outlined"
    />
  );
}
